<template>
    <li class="collection-header"><slot></slot></li>
</template>

<script>
    /**
     * collection header
     * @module collections/collection-header
     * @author Jack Yang
     * @description a component for collection-header
     */
    module.exports = {

    };
</script>


/** WEBPACK FOOTER **
 ** collection-header.vue?235502d3
 **/